import React from 'react'
import { Row, Col} from 'antd'
import EFSUsageReport from '../EFSUsage/efs-usage-report'
import EFSUsageChart from './efs-usage-chart'
import './efs-usage.scss'


export default ({selectedAccount, efsChartData, totalCost, efsUsageData}) => {
    let data = new window.google.visualization.DataTable()
    let formatter = new window.google.visualization.NumberFormat({
      pattern: ',###.## GB',
      fractionDigits: 2
    })

    data.addColumn('string', 'Topping')
    data.addColumn('number', 'Slices')



    if (efsUsageData.length > 0)
    {
        let efsUsageChartData = []
        efsUsageData.map((efsUsage) => {
            efsUsageChartData.push([efsUsage.name,((efsUsage.size_in_bytes.value/1024)/1024)/1024])
        })
        data.addRows(efsUsageChartData)
        formatter.format(data, 1)
        //console.log(efsUsageChartData)
    }



    efsChartData && efsChartData.sort((a, b) => b[1] - a[1])

    return (
    <div>
        <Row type="flex" gutter={30} className="overview-container">
        <Col span={10}>
                <Row>
                    <Col span={24}>
                        {efsUsageData && <EFSUsageReport title="Elastic File systems" efsUsageData={efsUsageData}  />}
                    </Col>
                </Row>
            </Col>

            <Col span={14}>
                <div className="overview-chart-container">
                   <EFSUsageChart efsChartData={data} />
                </div>
            </Col>
        </Row>
    </div>
)}
